// Chave própria, fora do namespace do cache de `query()`.
const CONFIRMED_ACCOUNT_KEY = 'admissions-confirmed-account';

const normalize = (email: string): string => email.trim().toLowerCase();

// sessionStorage: a confirmação vale só para a aba
export function saveConfirmedAccount(email?: string): void {
  if (!email) return;

  try {
    window.sessionStorage.setItem(CONFIRMED_ACCOUNT_KEY, normalize(email));
  } catch {
    // storage bloqueado (modo privado, cota): o modal volta a aparecer, que é o lado seguro.
  }
}

export function isAccountConfirmed(email?: string): boolean {
  if (!email) return false;

  try {
    return window.sessionStorage.getItem(CONFIRMED_ACCOUNT_KEY) === normalize(email);
  } catch {
    return false;
  }
}
